/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_CONTAR_ARR,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {Category, ManageSearch,Notes} from "@mui/icons-material";
import {ESTADOSUSUARIOS} from "../../Constantes";
import Dialogo_Catalogo from "../Dialogos/Catalogo/Dialogo_Producto";
import Dialogo_Producto_Variantes from "../Dialogos/Catalogo/Dialogo_Producto_Variantes";
import Dialogo_Producto_Informacion from "../Dialogos/Catalogo/Dialogo_Producto_Informacion";


const Seccion_Catalogo = () => {
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'productos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Catalogo,
        titulo: 'Detalles del producto',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoVariantes, abrir: abrirVariantes} = useDialogo({
        Componente: Dialogo_Producto_Variantes,
        titulo: 'Variantes del producto',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoInformacion, abrir: abrirInformacion} = useDialogo({
        Componente: Dialogo_Producto_Informacion,
        titulo: 'Variantes del producto',
        realizado: cargarNuevamente
    })



    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'variantes':
                abrirVariantes(data)
                break
            case 'informacion':
                abrirInformacion(data)
                break
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoVariantes/>

                <DialogoInformacion/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista productos'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Catalogo

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Marca',
        direccion: 'left',
        propiedad: 'marca',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Variantes',
        direccion: 'left',
        propiedad: 'variantes',
        tipo: CASILLA_CONTAR_ARR

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSUSUARIOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Variantes',
        id: 'variantes',
        icono: Category
    },
    {
        nombre: 'Informacion',
        id: 'informacion',
        icono: Notes
    },

]